import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { INITIAL_IMAGE_HASH_ARRAY } from '@/constants/imageHashes'
import App from './App.vue'
import router from './router'
import 'ant-design-vue/dist/reset.css'
import { i18n } from './i18n.js'

// 引入固定 rem 适配
import initFixedRem from './utils/rem'
// 添加图片crc数据容器
if (!localStorage.getItem('CustomImageHashArray')) {
    localStorage.setItem('CustomImageHashArray', JSON.stringify(INITIAL_IMAGE_HASH_ARRAY))
}
// 初始化固定 rem
initFixedRem()

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(i18n)
app.mount('#app')
